import { createSelector } from 'reselect';

const selectAllProjects = (state) => state.projects.items || [];

const selectRequestStatus = (state) => state.projects.status;

const selectProjectById = (projectId) => createSelector(
  selectAllProjects,
  (projects) => projects.find((project) => project._id === projectId) || {},
);

const selectProjectByIdV2 = createSelector(
  selectAllProjects,
  (state, projectId) => projectId,
  (projects, projectId) => projects.find((project) => project._id === projectId) || {},
);

const selectProjectByUserRoleAndId = (userRole, userId) => createSelector(
  selectAllProjects,
  (projects) => projects.find((project) => project[`${userRole}Id`] === userId) || {},
);

const selectProjectForAccount = (userId) => createSelector(
  selectAllProjects,
  (projects) => projects.filter(({ members = [] }) => members.some(({ _id }) => _id === userId)),
);

const selectProjectsByUserRoleAndId = (userId, userRole) => createSelector(
  selectAllProjects,
  (projects) => projects.filter((project) => project[`${userRole}Id`] === userId) || [],
);

const selectProjectByCustomerOrProjectId = (id) => createSelector(
  selectAllProjects,
  (projects) =>
    projects.find((project) => (project.customerId === id) || (project._id === id)) || {},
);

export default {
  selectAllProjects,
  selectProjectById,
  selectProjectByIdV2,
  selectRequestStatus,
  selectProjectByUserRoleAndId,
  selectProjectForAccount,
  selectProjectsByUserRoleAndId,
  selectProjectByCustomerOrProjectId,
};
